import {
  ComplianceCheckModel,
  InspectionModel,
  ProtocolItemModel,
  ProtocolSectionModel,
} from 'shared/domain/inspection/inspectionModel';
import {
  ComplianceCheckEntity,
  InspectionEntity,
  ProtocolItemEntity,
  ProtocolSectionEntity,
} from './entity';
import { UserEntity } from 'shared/domain/user/types/entity';
import {
  entityToModelBase,
  entityToNonCreatableModelBase,
} from 'shared/domain/toBaseModel';

export function inspectionEntityToModel(
  inspectionEntity: InspectionEntity,
  users: UserEntity[]
): InspectionModel {
  const modelBase = entityToModelBase({ entity: inspectionEntity, users });
  return {
    ...modelBase,
    contracts: inspectionEntity.contracts,
    controlledParty: inspectionEntity.controlledParty,
    inspectionDate: inspectionEntity.inspectionDate,
    isCompleted: inspectionEntity.isCompleted,
    levels: inspectionEntity.levels,
    protocol: inspectionEntity.protocol.map((protocolItem) =>
      protocolEntityToModel(protocolItem, users)
    ),
    sections: (inspectionEntity.sections || []).map((section) =>
      protocolSectionEntityToModel(section, inspectionEntity)
    ),
    sites: inspectionEntity.sites,
    template: inspectionEntity.template,
    workTypes: inspectionEntity.workTypes,
    comment: inspectionEntity.comment,
  };
}

function protocolEntityToModel(
  protocolEntity: ProtocolItemEntity,
  users: UserEntity[]
): ProtocolItemModel {
  const modelBase = entityToNonCreatableModelBase({
    entity: protocolEntity,
    users,
  });
  return {
    ...modelBase,
    complianceCheck: complianceCheckEntityToModel(
      protocolEntity.complianceCheck
    ),
    templateChecklistItem: protocolEntity.templateChecklistItem,
    answers: protocolEntity.answers,
  };
}

function complianceCheckEntityToModel(
  complianceCheckEntity: ComplianceCheckEntity
): ComplianceCheckModel {
  return {
    issues: complianceCheckEntity.issues,
    result: complianceCheckEntity.result,
    comment: complianceCheckEntity.comment,
  };
}

function protocolSectionEntityToModel(
  sectionEntity: ProtocolSectionEntity,
  inspectionEntity: InspectionEntity
): ProtocolSectionModel {
  return {
    _id: sectionEntity._id,
    title: sectionEntity.title || '',
    checklistSectionId: sectionEntity.checklistSectionId,
    comment: sectionEntity.comment ?? sectionEntity.description ?? '',
    order: sectionEntity.order || '',
    parentSectionId: sectionEntity.parentSectionId ?? null,
    createdAt: sectionEntity.createdAt || inspectionEntity.createdAt,
    createdBy: undefined,
    modifiedAt: sectionEntity.modifiedAt || inspectionEntity.modifiedAt,
    modifiedBy: undefined,
  };
}
